import React, { useState, useContext } from "react"
import { Mutation } from "react-apollo"
import REMOVE_FAVORITE from "../../../../graphql/removeFavorite.graphql"
import { getRecentFavorites } from "../../queries"
import Button from "../../../../components/Button"
import { MESSAGE_TYPE } from "./const"
import { FormButtomGroup, DeleteFavoriteWrap } from "./displays"
import { ModalMessage } from "../../../../components/Modal"
import AppContext from "../../../../shared/AppContext"

const FavoriteDelete = (props) => {
  const {
    closeModal,
    name,
    removeFavorite,
    refetchQuery,
    favoriteId,
    trackingLocation,
  } = props
  const { trackEvent } = useContext(AppContext)

  const [message, setMessage] = useState({ type: "", text: "" })

  const handleCloseModal = () => {
    props.closeModal()
    if (refetchQuery) {
      refetchQuery()
    }
  }

  const handleRemove = () => {
    removeFavorite({
      variables: {
        favoriteId: favoriteId,
      },
      refetchQueries: [{ query: getRecentFavorites }],
    })
      .then(({ data }) => {
        const { deleteFavoritesFile } = data
        setMessage({
          type: deleteFavoritesFile.response.payload,
          text: deleteFavoritesFile.response.message,
        })
        if (
          deleteFavoritesFile.response &&
          deleteFavoritesFile.response.payload === MESSAGE_TYPE.SUCCESS
        )
          trackEvent("Deleted Favorite", {
            location: trackingLocation,
            favoriteName: name,
          })
      })
      .catch((err) => {
        setMessage({
          type: MESSAGE_TYPE.SAVE_ERROR,
          text:
            "Oh no! Something went wrong. Please go to https://app.etr.ai/help to get support.",
        })
        console.log("delete favorite", err)
      })
  }

  if (message.type == MESSAGE_TYPE.SUCCESS) {
    return (
      <ModalMessage
        messageType={MESSAGE_TYPE.SUCCESS}
        text={message.text}
        closeModal={handleCloseModal}
      />
    )
  } else {
    return (
      <DeleteFavoriteWrap>
        <p>Please confirm that you want to delete this favorite.</p>
        <p
          style={{
            padding: ".8rem",
            fontSize: "2rem",
            fontStyle: "italic",
            fontWeight: "100",
          }}
        >
          {name}
        </p>
        {message.type == MESSAGE_TYPE.SAVE_ERROR && (
          <ModalMessage
            messageType={MESSAGE_TYPE.SAVE_ERROR}
            text={message.text}
            style={{ textAlign: "right" }}
          />
        )}
        <FormButtomGroup>
          <Button
            action={closeModal}
            classes={["btn-cancel"]}
            style={{ marginRight: ".8rem" }}
          >
            Cancel
          </Button>
          <Button
            action={handleRemove}
            text="Confirm Delete"
            classes={["btn-primary"]}
          />
        </FormButtomGroup>
      </DeleteFavoriteWrap>
    )
  }
}

const FavoriteDeleteWithMutation = (props) => {
  return (
    <Mutation mutation={REMOVE_FAVORITE}>
      {(removeFavorite) => {
        return <FavoriteDelete {...props} removeFavorite={removeFavorite} />
      }}
    </Mutation>
  )
}

export default FavoriteDeleteWithMutation
